import { render, staticRenderFns } from "./LoginDialogPc.vue?vue&type=template&id=5237e6a9"
import script from "./LoginDialogPc.vue?vue&type=script&lang=js"
export * from "./LoginDialogPc.vue?vue&type=script&lang=js"
import style0 from "./LoginDialogPc.vue?vue&type=style&index=0&id=5237e6a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports